// chartSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentChartTypePerformance: null,
};

const brandPerformanceChartSlice = createSlice({
  name: 'brandPerformanceChart',
  initialState,
  reducers: {
    setCurrentChartTypePerformance: (state, action) => {
      state.currentChartTypePerformance = action.payload;
    },
  },
});

export const { setCurrentChartTypePerformance } = brandPerformanceChartSlice.actions;
export default brandPerformanceChartSlice.reducer;